// Lumiere Jewelry — scroll motion (lightweight GSAP via ScrollTrigger)
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  function loadGsap() {
    if (window.gsap) {
      initMotion();
      return;
    }
    var s = document.createElement("script");
    s.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js";
    s.onload = function () {
      var st = document.createElement("script");
      st.src = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js";
      st.onload = initMotion;
      document.head.appendChild(st);
    };
    document.head.appendChild(s);
    // Safety net: if GSAP never arrives, keep everything visible.
    setTimeout(function () {
      if (!window.gsap) {
        document.documentElement.classList.add("no-gsap");
      }
    }, 4000);
  }

  function initMotion() {
    gsap.registerPlugin(ScrollTrigger);

    // Hero entrance
    gsap.from("[class*='hero'] h1", {
      y: 40,
      opacity: 0,
      duration: 1.1,
      ease: "power3.out",
      delay: 0.1,
    });
    gsap.from("[class*='hero'] p", {
      y: 24,
      opacity: 0,
      duration: 0.9,
      ease: "power2.out",
      delay: 0.25,
    });
    gsap.from("[class*='hero'] a, [class*='hero'] button", {
      y: 20,
      opacity: 0,
      duration: 0.8,
      ease: "power2.out",
      delay: 0.4,
      stagger: 0.1,
    });

    // Fade-up reveal: immediateRender:false keeps content visible until triggered.
    gsap.utils.toArray("[class*='section'] h2, [class*='section'] h3, [class*='collection-list'] [class*='card'], [class*='product-card']").forEach(function (el) {
      gsap.fromTo(
        el,
        { y: 24, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.9,
          ease: "power3.out",
          immediateRender: false,
          scrollTrigger: {
            trigger: el,
            start: "top 96%",
            once: true,
            invalidateOnRefresh: true,
          },
        }
      );
    });

    // Image scale reveal — images stay fully visible, only a gentle scale on enter.
    gsap.utils.toArray("[class*='collection'] img, [class*='product-card'] img, [class*='card'] img").forEach(function (img) {
      gsap.fromTo(
        img,
        { scale: 0.97 },
        {
          scale: 1,
          duration: 1,
          ease: "power2.out",
          immediateRender: false,
          scrollTrigger: { trigger: img, start: "top 92%", once: true, invalidateOnRefresh: true },
        }
      );
    });

    // Recalculate positions after layout settles.
    window.addEventListener("load", function () { ScrollTrigger.refresh(); });
    setTimeout(function () { ScrollTrigger.refresh(); }, 1500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", loadGsap);
  } else {
    loadGsap();
  }
})();
